//* 지망생이 호출하는 코치 정보 관련 API
// 2025.01.27
// 희문

import * as BaseApi from "api/Base.api";
import { IUserKoach } from "api/interfaces/user.interface";

const BASE_URL = "/student/v2/koach";

//* 코치 정보 응답 인터페이스
export interface IKoachInfoResponse {
    koach: IUserKoach
}

//* 코치 목록 조회 응답 인터페이스
export interface IKoachListResponse {
    koachList: Array<{
        id: number;
        nickname?: string;
        profileImageInfo?: { id: string; url: string };
        profileImage?: any;
        isFollowing?: boolean;
        hasNewContent?: boolean;
        latestContentId?: number;
    }>;
}

//* 코치 목록 조회
// 2025.01.18
// 희문
//* Params
// limit?: number
export const getKoachList = async (limit?: number): Promise<IKoachListResponse> => {
    const url = `${BASE_URL}${limit ? `?limit=${limit}` : ''}`;
    return await BaseApi.get(url);
};

//* 코치 정보 조회
// 2025.01.27
// 희문
//* Params
// koachId: string
export const getKoachInfo = async (koachId: string): Promise<IKoachInfoResponse> => {
    const url = `${BASE_URL}/${koachId}`;
    return await BaseApi.get(url);
};

//* 팔로우 토글 응답 인터페이스
export interface IToggleKoachFollowResponse {
    isFollowing: boolean;
    message: string;
}

//* 코치 팔로우 토글
// 2025.01.18
// 희문
//* Params
// koachId: string
export const toggleKoachFollow = async (koachId: string): Promise<IToggleKoachFollowResponse> => {
    const url = `${BASE_URL}/${koachId}/follow`;
    const response = await BaseApi.post(url, {}) as any;
    return response.data as IToggleKoachFollowResponse;
};
